// Klant-afkortingen ("Omgevingsdienst Midden- en West-Brabant" → "OMWB") voor
// compacte weergaves. Eén centrale map, beheerd in Admin → Klant-afkortingen,
// opgeslagen in de engine-settings. Module-cache zodat sync-helpers als
// taskProjectLabel hem direct kunnen gebruiken; de hook triggert een re-render
// zodra de map binnen is.
import { useEffect, useState } from 'react';
import { AI_ENGINE_URL } from './apiConfig';
import { authFetch } from './authHelpers';

let cache = null;          // { volledigeNaam: afkorting }
let accountNamen = {};     // { bedrijfsnaam: overkoepelende accountnaam } — automatische laag
let belofte = null;

export function laadKlantAfkortingen() {
  if (cache) return Promise.resolve(cache);
  if (!belofte) {
    belofte = authFetch(`${AI_ENGINE_URL}/api/v1/instellingen/klant-afkortingen`)
      .then((r) => (r.ok ? r.json() : { afkortingen: {} }))
      .then((d) => { cache = d.afkortingen || {}; accountNamen = d.account_namen || {}; return cache; })
      .catch(() => { cache = {}; return cache; });
  }
  return belofte;
}

/** Sync: afkorting als die bestaat, anders de volledige naam. */
export function kortKlant(naam) {
  const n = String(naam || '').trim();
  if (!n) return n;
  // Keten: expliciete afkorting → overkoepelend account (Enexis Personeel BV
  // → Enexis) → volle naam. Het account alleen als het écht korter is.
  if (cache && cache[n]) return cache[n];
  const account = accountNamen[n];
  if (account && account.length < n.length) return account;
  return n;
}

/** Hook: laadt de map en her-rendert het scherm zodra hij er is. */
export function useKlantAfkortingen() {
  const [, setKlaar] = useState(Boolean(cache));
  useEffect(() => { laadKlantAfkortingen().then(() => setKlaar(true)); }, []);
  return kortKlant;
}

/** Voor het beheerscherm: verse map + opslaan (ververst de cache). */
export async function haalKlantAfkortingen() {
  cache = null; belofte = null;
  return laadKlantAfkortingen();
}
export async function bewaarKlantAfkortingen(map, updatedBy) {
  const r = await authFetch(`${AI_ENGINE_URL}/api/v1/instellingen/klant-afkortingen`, {
    method: 'PUT', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ afkortingen: map, updated_by: updatedBy || '' }),
  });
  if (!r.ok) throw new Error('Opslaan mislukt');
  cache = { ...map };
  return cache;
}
